import React from 'react';
import useCustomRoles from './hooks/useCustomRoles';
import RNPTable from '../RNPTable/RNPTable';
import { RNPAction, RNPActionsContext } from '../RNPTable/RNPActions/context';
import {
  NO_CUSTOM_ROLES_DESCRIPTION_MESSAGE,
  NO_CUSTOM_ROLES_TITLE_MESSAGE,
  ORGANIZATION,
  PERMISSIONS,
  ROLE_NAME,
} from '../../../utils/constants';

const CustomRoles = () => {
  const {
    rolesResponse: {
      isLoading,
      error,
      totalCount,
      roles,
      currentPage,
      totalPages,
    },
    isViewOnlyRole,
    setCurrentPage,
    pageStats,
    onEdit,
    onDelete,
  } = useCustomRoles();

  const noItemsContent = {
    title: NO_CUSTOM_ROLES_TITLE_MESSAGE,
    description: NO_CUSTOM_ROLES_DESCRIPTION_MESSAGE,
  };

  const headerTitles = [
    { title: ROLE_NAME, className: 'rnp-role-name' },
    { title: PERMISSIONS, className: 'rnp-permissions' },
    { title: ORGANIZATION, className: 'rnp-module' },
    { title: '', className: 'rnp-actions' },
  ];

  return (
    <RNPActionsContext.Provider
      value={{
        actionsToRender: [RNPAction.delete],
        onDelete,
        onEdit,
      }}
    >
      <RNPTable
        headerTitles={headerTitles}
        noItemsContent={noItemsContent}
        isLoading={isLoading}
        error={error}
        isViewOnlyRole={isViewOnlyRole}
        roles={roles}
        totalCount={totalCount}
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        pageStats={pageStats}
      />
    </RNPActionsContext.Provider>
  );
};

export default CustomRoles;
